module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T"
  }, [_c('strong', [_vm._v("Pompom Cushion")])]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("This stockinette stitch cushion is embellished with pompoms made from primary colors to brighten up a child’s room.")]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_c('strong', [_c('em', [_vm._v("Skill Level-Beginner")])])]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/Images/4-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("You Will Need")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Yarn")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  2 × 2"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz (100g) balls of light-weight (DK) acrylic yarn (322yd/295m per ball) in cream (A)")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  For pompoms: 1 × 1"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz (50g) ball of each of blue, red, green and yellow acrylic or wool yarn")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Knitting Needles")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  One pair size 6 (4mm)")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Other Materials")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  16in (40cm) square cushion pad")])]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Finished Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("16in (40cm) square")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Gauge")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("22 sts and 28 rows to 4in (10cm) square measured over st st (1 row k, 1 row p) using size 6 (4mm) needles")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Knit Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("You could use shop-bought pompoms, but it’s much more fun to make your own, and you can create exactly the colors and textures you want.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Knit Your Cushion")])]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_c('strong', [_vm._v("BACK AND FRONT (MAKE 2 THE SAME)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Using size 6 (4mm) needles and A, cast on 88 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Work in st st (1 row k, 1 row p) until work measures 16in (40cm), ending with a p row.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Bind off.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Finish Your Cushion")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Sew in all ends neatly. Press according to instructions on ball bands.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Make sufficient pompoms to cover the front of the cushion. Sew the pompoms on.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Join back and front together around three sides. Insert cushion pad and sew remaining side closed.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_c('strong', [_vm._v("MAKING A POMPOM")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Cut two circles out of stiff cardboard, making them the same diameter that you require for the finished pompom. Cut out a hole in the center of each one half of this size. Place the card circles together and begin winding yarn around them until the hole in the center is filled ("), _c('a', {
    attrs: {
      "href": "#/OEBPS/#fig1"
    }
  }, [_vm._v("Fig 1")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Carefully cut through the loops all the way around, being careful not to let any yarn strands escape ("), _c('a', {
    attrs: {
      "href": "#/OEBPS/#fig2"
    }
  }, [_vm._v("Fig 2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Pull a length of yarn between the two pieces of cardboard, knot the two ends together and pull tightly around the center of the pompom. Secure with a tight knot ("), _c('a', {
    attrs: {
      "href": "#/OEBPS/#fig3"
    }
  }, [_vm._v("Fig 3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Pull out the cardboard circles. Fluff up the pompom, trimming any uneven ends, but leave the two yarn ends for sewing on.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1",
    staticStyle: {
      "margin-top": "1em",
      "font-size": "17pt"
    }
  }, [_c('strong', [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "Image-C",
    attrs: {
      "id": "fig1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/Images/7-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1",
    staticStyle: {
      "margin-top": "1em",
      "font-size": "17pt"
    }
  }, [_c('strong', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "Image-C",
    attrs: {
      "id": "fig2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/Images/7-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1",
    staticStyle: {
      "margin-top": "1em",
      "font-size": "17pt"
    }
  }, [_c('strong', [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "Image-C",
    attrs: {
      "id": "fig3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/Images/7-3.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42756142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 63
// module chunks = 0